module["exports"] = ["(##) ####-####", "+55 (##) ####-####", "(##) #####-####"];